import { createContext, useContext, useState } from "react";
import { Pencil, X } from "lucide-react";

export const EditCtx = createContext({ editing: false });
export const useDeckEdit = () => useContext(EditCtx);

// Click-to-type text. Visitors see plain text; editors see a dashed hover outline.
export function Editable({ value, onChange, as: Tag = "span", className = "", style, placeholder = "Click to edit", testid }) {
  const { editing } = useDeckEdit();
  if (!editing) return value ? <Tag className={className} style={style} data-testid={testid}>{value}</Tag> : null;
  return (
    <Tag contentEditable suppressContentEditableWarning spellCheck data-testid={testid} data-placeholder={placeholder}
      onBlur={(e) => { const v = e.currentTarget.innerText.replace(/\n{3,}/g, "\n\n").trim(); if (v !== (value || "")) onChange?.(v); }}
      onKeyDown={(e) => { if (e.key === "Escape") e.currentTarget.blur(); }}
      className={`${className} deck-editable outline-none rounded-sm cursor-text`} style={style}>{value || ""}</Tag>
  );
}

// Opens a panel (market tables, site data, exits, video…) while editing.
export function EditPanelButton({ label, title, children, testid, dark }) {
  const { editing } = useDeckEdit();
  const [open, setOpen] = useState(false);
  if (!editing) return null;
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={testid}
        className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-medium shadow-sm transition-transform hover:scale-[1.03] ${dark ? "bg-white/90 text-slate-900" : "bg-[#2C6B66] text-white"}`}>
        <Pencil className="h-3.5 w-3.5" />{label}
      </button>
      {open && (
        <div className="fixed inset-0 z-[110] flex justify-end" data-testid={`${testid}-panel`}>
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <aside className="dark relative h-full w-full sm:w-[460px] overflow-y-auto bg-background text-foreground p-5 shadow-2xl">
            <div className="flex items-center justify-between mb-4"><div className="font-semibold">{title || label}</div>
              <button onClick={() => setOpen(false)} className="p-1 rounded hover:bg-secondary" data-testid={`${testid}-close`}><X className="h-4 w-4" /></button></div>
            {children}
          </aside>
        </div>
      )}
    </>
  );
}
